import { TaskGroup } from '../apis/tasksApi';
import { TaskStatus } from '../types';
import { DasEndpointType } from '../types/Device';

export const taskGroupPayloadTypeList = [
  {
    id: 'all',
    name: 'All',
    value: 'all',
  },
  {
    id: 'dasloopPlayAudio',
    name: 'Dasloop Play Audio',
    value: 'dasloopPlayAudio',
  },
  {
    id: 'dasmainUpdateAudio',
    name: 'Dasmain Update Audio',
    value: 'dasmainUpdateAudio',
  },
  {
    id: 'dasloopProtocolWriteDeviceConfigurationFile',
    name: 'Write Device Configuration File',
    value: 'dasloopProtocolWriteDeviceConfigurationFile',
  },
  {
    id: 'dasloopProtocolReadDeviceConfigurationFile',
    name: 'Read Device Configuration File',
    value: 'dasloopProtocolReadDeviceConfigurationFile',
  },
  {
    id: 'dasloopProtocolSetOperationMode',
    name: 'Set Operation Mode',
    value: 'dasloopProtocolSetOperationMode',
  },
  {
    id: 'dasloopProtocolSystemReset',
    name: 'System Reset',
    value: 'dasloopProtocolSystemReset',
  },
  {
    id: 'smartlockAuthorizedCardManagement',
    name: 'Authorized Card Management',
    value: 'smartlockAuthorizedCardManagement',
  },
  {
    id: 'smartlockRegisterCardManagement',
    name: 'Register Card Management',
    value: 'smartlockRegisterCardManagement',
  },
  {
    id: 'smartlockStaticPasswordUnlock',
    name: 'Static Password Unlock',
    value: 'smartlockStaticPasswordUnlock',
  },
  {
    id: 'smartlockSublockUnlock',
    name: 'Sublock Unlock',
    value: 'smartlockSublockUnlock',
  },
  {
    id: 'loraSmartlockConfigSet',
    name: 'lora Smartlock Config Set',
    value: 'lora Smartlock Config Set',
  },
  {
    id: 'dasloopProtocolUpdateConfig',
    name: 'Dasloop Protocol Update Config',
    value: 'dasloopProtocolUpdateConfig',
  },
  {
    id: 'dasloopProtocolUpdateFirmware',
    name: 'Dasloop Protocol Update Firmware',
    value: 'dasloopProtocolUpdateFirmware',
  },
];

export function getTaskGroupType(id: string): string | undefined {
  const task = taskGroupPayloadTypeList.find((task) => task.id === id);
  return task ? task.name : undefined;
}

export const getTextStatus = (status: TaskStatus) => {
  switch (status) {
    case 'inProgress':
      return 'In Progress';
    case 'canceled':
      return 'Canceled';
    case 'completed':
      return 'Completed';
    case 'failed':
      return 'Failed';
    default:
      return null;
  }
};

export const getCreateDate = (taskGroup: TaskGroup) => {
  return new Date(taskGroup.createdAt);
};

export const getFinishDate = (taskGroup: TaskGroup) => {
  return new Date(
    taskGroup.tasks.reduce((latest, task) => {
      const taskTime = new Date(task.updatedAt).getTime();
      return taskTime > latest ? taskTime : latest;
    }, 0),
  );
};

export const getDeviceTypeBasedTask = (taskGroup: TaskGroup) => {
  let deviceType: DasEndpointType | undefined;
  switch (taskGroup.type) {
    case 'dasloopPlayAudio':
    case 'dasmainUpdateAudio':
    case 'dasloopProtocolWriteDeviceConfigurationFile':
    case 'dasloopProtocolReadDeviceConfigurationFile':
    case 'dasloopProtocolSetOperationMode':
    case 'dasloopProtocolSystemReset':
      deviceType = 'dasloop';
      break;
    case 'smartlockAuthorizedCardManagement':
    case 'smartlockRegisterCardManagement':
    case 'smartlockStaticPasswordUnlock':
    case 'smartlockSublockUnlock':
      deviceType = 'daslock';
      break;
    default:
      break;
  }

  return deviceType;
};

export const DEFAULT_DASLOOP_PROTOCOL_TASK_TIMEOUT = 180000;
